import * as contentActions from './contentReducer';
import Axios from 'axios';
import queryString from '../../../helpers/queryString';
import { push } from 'react-router-redux';
import handleErrorResponse from '../../../helpers/handleErrorResponse';
import getIncludedResource from '../../../helpers/getIncludedResource';
import { ADD_RESOURCE } from '../../layout/redux/breadcrumb';
import { forEach, head } from 'lodash';
import capitalize from 'react-bootstrap/lib/utils/capitalize';

const isFetching = (status) => ({ type: contentActions.IS_FETCHING, status });

/**
 * Creates a new content resource
 * @returns {{type, data: *}}
 */
const createContent = (resource, includes = ['template', 'files']) => {
  return (dispatch) => {
    const endpoint = 'contents/' + queryString(includes);

    return Axios.post(endpoint, resource)
      .then((response) => {
        dispatch({
          type: contentActions.SET_CONTENT,
          data: response.data,
        });

        dispatch(push('/admin/content/' + response.data.data.id));
        return true;
      })
      .catch((error) => {
        handleErrorResponse(error, 'There was an error creating your content');
      });
  };
};

/**
 * Loads the content for the requested id
 * @param id
 * @param includes
 * @returns {{type, data: *}}
 */
const getContent = (id, includes = ['template', 'files', 'channels', 'products']) => {
  return (dispatch) => {
    const endpoint = 'contents/' + id + queryString(includes);

    return Axios.get(endpoint)
      .then((response) => {
        dispatch({
          type: contentActions.SET_CONTENT,
          data: response.data,
        });
        dispatch({
          type: ADD_RESOURCE,
          id: response.data.data.id,
          name: response.data.data.attributes.name,
        });
        return true;
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

/**
 * Loads the content for editing meta information
 * @returns {{type, data: *}}
 */
const getContentForMetaInfo = () => {
  return (dispatch) => {
    const endpoint =
      'contents/?page[limit]=250&filter[template.key]=brand-page,basic-page,basic-page-with-button,article,home-page&include=template';

    return Axios.get(endpoint)
      .then((response) => {
        const metaInfoGrouped = {
          pages: [],
          blogs: [],
          brands: [],
        };

        const metaInfo = response.data;
        metaInfo &&
          forEach(metaInfo.data, (info) => {
            const template = getIncludedResource(info, metaInfo.included, 'template');
            if (
              template.data.attributes.key === 'basic-page' ||
              template.data.attributes.key === 'basic-page-with-button' ||
              template.data.attributes.key === 'home-page' ||
              template.data.attributes.key === 'questions-page' ||
              template.data.attributes.key === 'contact-us'
            ) {
              metaInfoGrouped['pages'].push(info);
            }

            if (template.data.attributes.key === 'article') {
              metaInfoGrouped['blogs'].push(info);
            }

            if (template.data.attributes.key === 'brand-page') {
              metaInfoGrouped['brands'].push(info);
            }
          });

        dispatch({
          type: contentActions.SET_CONTENT_FOR_META_INFO,
          data: metaInfoGrouped,
        });
        return true;
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

/**
 * clear metaInfo to force re-fetch
 * @returns {Function}
 */
const clearMetaInfo = () => {
  return (dispatch) => {
    dispatch({
      type: contentActions.CLEAR_CONTENT_FOR_META_INFO,
    });
  };
};

/**
 * Updates a content resource
 * @param resource
 * @param itemId
 * @param includes
 * @returns {function(*, *): Promise<boolean>}
 */
const updateMetaInfo = (resource, itemId = null, includes = ['template', 'files']) => {
  return (dispatch) => {
    const endpoint = 'contents/' + itemId + queryString(includes);
    return Axios.patch(endpoint, resource)
      .then(() => {
        dispatch(clearMetaInfo());

        return true;
      })
      .then(() => {
        dispatch(getContentForMetaInfo());
      })
      .catch((error) => {
        handleErrorResponse(error, 'There was an error updating your content');
      });
  };
};

/**
 * Updates a content resource
 * @param resource
 * @param includes
 * @returns {{type, data: *}}
 */
const updateContent = (resource, includes = ['template', 'files']) => {
  return (dispatch) => {
    const endpoint = 'contents/' + resource.data.id + queryString(includes);

    return (
      Axios.patch(endpoint, resource)
        .then((response) => {
          // dispatch(clearMetaInfo())
          dispatch({
            type: contentActions.SET_CONTENT,
            data: response.data,
          });

          dispatch(push('/admin/content/' + response.data.data.id));
          return true;
        })
        // .then(() => {
        //   dispatch(getContentForMetaInfo())
        // })
        .catch((error) => {
          handleErrorResponse(error, 'There was an error updating your content');
        })
    );
  };
};

// const getTemplates = (type) => {
//   const endpoint = 'templates?page[limit]=500&filter[template_type]=' + type;
//   return Axios.get(endpoint).then(response => {
//     return response.data.data
//   }).catch(error => {
//     console.error(error)
//   })
// };

const getTemplate = (templateType) => {
  return (dispatch) => {
    dispatch(isFetching(true));
    const endpoint = `templates?filter[template_type]=${templateType}`;
    return Axios.get(endpoint)
      .then((response) => {
        dispatch(setTemplate(head(response.data.data)));
        dispatch(isFetching(false));
        return true;
      })
      .catch((error) => {
        dispatch(isFetching(false));
        console.error(error);
      });
  };
};

const setTemplate = (template) => {
  return {
    type: contentActions.SET_TEMPLATE_INFO,
    data: template,
  };
};

const reset = () => {
  return (dispatch) => {
    dispatch({
      type: contentActions.RESET,
    });
  };
};

const getSignposts = () => {
  return (dispatch) => {
    dispatch(isFetching(true));
    const endpoint = 'signposts?filter[status]=active';
    return Axios.get(endpoint)
      .then((response) => {
        return response.data.data;
      })
      .finally(() => {
        dispatch(isFetching(false));
      });
  };
};
const getSignpost = (id) => {
  return (dispatch) => {
    dispatch(isFetching(true));
    const endpoint = `signposts/${id}`;
    return Axios.get(endpoint)
      .then((response) => {
        dispatch({
          type: ADD_RESOURCE,
          id: response.data.data.id,
          name: capitalize(response.data.data.attributes.name.replaceAll('_', ' ')),
        });
        return response.data;
      })
      .finally(() => {
        dispatch(isFetching(false));
      });
  };
};

const updateSignpost = (id, values) => {
  return (dispatch) => {
    dispatch(isFetching(true));
    const endpoint = `signposts/${id}`;
    return Axios.patch(endpoint, values)
      .then((response) => {
        dispatch(push(`/admin/content/signpost/${response.data.data.id}/edit`));
      })
      .finally(() => {
        dispatch(isFetching(false));
      });
  };
};

export const actions = {
  createContent,
  getContent,
  getContentForMetaInfo,
  clearMetaInfo,
  updateMetaInfo,
  updateContent,
  getTemplate,
  //getTemplates,
  setTemplate,
  reset,
  getSignposts,
  getSignpost,
  updateSignpost,
};
